import { createReducer } from 'typesafe-actions';
import type { DeviceType } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

import { setDeviceType, ThemeActions } from 'rdx/theme/actions';

export interface ThemeState {
  deviceType: DeviceType;
}

export const initialState: Readonly<ThemeState> = {
  deviceType: 'desktop',
};

function updateDeviceTypeState(state: ThemeState, action: ThemeActions): ThemeState {
  const targetDeviceType = action.payload;
  if (state.deviceType === targetDeviceType) {
    return state;
  }

  return { ...state, deviceType: targetDeviceType };
}

export const themeReducer = createReducer<ThemeState, ThemeActions>(initialState).handleAction(
  setDeviceType,
  updateDeviceTypeState,
);
